import { useState } from "react";
import {
  useParams,
  NavLink,
  useHistory,
  Switch,
  Route,
  Redirect,
} from "react-router-dom";
import Breadcrumb from "react-bootstrap/Breadcrumb";

import styles from "./App.module.scss";
import overview from "../../../Assets/applifecycle/overview.svg";
import storelisting from "../../../Assets/applifecycle/store-listing.svg";
import releasemanagement from "../../../Assets/applifecycle/release-management.svg";
import buildhistory from "../../../Assets/applifecycle/build-history.svg";
import bugreport from "../../../Assets/applifecycle/bug-reports.svg";
import arrowdown from "../../../Assets/arrowdown.svg";
import AnalyticsIcon from "../../../Assets/analyticsIcon.svg";
import Sidebar from "../../../components/consolecomponents/sidebar/Sidebar";
import Overview from "./overview/Overview";
import AppManage from "./appManage/AppManage";
import ComingSoonModal from "../../../components/consolecomponents/modal/ComingSoonModal";
import BuildHistory from "./buildHistory/BuildHistory";
import { useAllApps, useOneApp } from "../../../hooks/DevAppHooks";
import IsLoading from "../../../util/loader/IsLoading";
import { useOneProject } from "../../../hooks/DevProjectHooks";
import AppAnalytics from "../../analytics";

const App = ({ match }) => {
  const [showApp, setShowApp] = useState(false);
  const { appid, projectid } = useParams();

  const [showComingSoon, setShowComingSoon] = useState(false);
  const history = useHistory();

  /**
   * Api calls:
   * - OneProject for breadcrumb
   * - AllApps for sidebar navigation b/w apps
   * - OneApp for rendering details
   */
  const {
    data: project,
    isLoading: projectLoading,
    isError: projectError,
  } = useOneProject(projectid, () => "placeholder");
  const {
    data: apps,
    isLoading: appsLoading,
    isError: appsError,
  } = useAllApps(projectid);
  const { data: app, isLoading, isError } = useOneApp(appid);
  /**
   * Rendering after fetching
   */
  if (appsLoading || isLoading || projectLoading) {
    return <IsLoading />;
  }

  return (
    <>
      <ComingSoonModal
        showComingSoon={showComingSoon}
        setShowComingSoon={setShowComingSoon}
      />
      <div className={styles.container}>
        <Sidebar setShowComingSoon={setShowComingSoon}>
          <section className="sidebar_app">
            <div
              onClick={() => history.push("/console/")}
              className="sidebar_projects"
            >
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  padding: "0.5em",
                }}
              >
                <h3 onClick={() => history.push("/console/")}>Go To Project</h3>
              </div>
            </div>
          </section>
          <section className="sidebar_app">
            <div
              onClick={() => setShowApp(!showApp)}
              className="sidebar_projects"
            >
              <div style={{ display: "flex", justifyContent: "space-between" }}>
                <h3
                  onClick={() =>
                    showApp ? history.push(`/console/${projectid}`) : null
                  }
                  className={`${showApp ? "inactive" : ""}`}
                >
                  {showApp ? `All Apps` : app?.title}
                </h3>
                <img
                  src={arrowdown}
                  alt="logo"
                  className="mr-1 fluid logo"
                  style={{
                    width: "0.75rem",
                    height: "0.75rem",
                    marginLeft: "0.25rem",
                  }}
                />
              </div>

              {showApp ? (
                <ul className="sidebar_projectlist">
                  {apps &&
                    Array.isArray(apps) &&
                    apps.map((app) => (
                      <li key={app.id}>
                        <NavLink
                          activeClassName="active"
                          to={`/console/${projectid}/${app.id}`}
                        >
                          <span className="sidebar_list_items">
                            {app.title}
                          </span>
                        </NavLink>
                      </li>
                    ))}
                </ul>
              ) : null}
            </div>
          </section>
          <section className="panel_tertiary_container">
            <ul className="sidebar_list_secondary">
              <li className="">
                <NavLink
                  exact
                  activeClassName="active"
                  to={`/console/${projectid}/${app.id}`}
                >
                  <img src={overview} alt="logo" className="sidebar_card_img" />
                  App Overview
                </NavLink>
              </li>
              <li className="">
                <NavLink exact activeClassName="inactive" to="#">
                  <img
                    src={storelisting}
                    alt="logo"
                    className="sidebar_card_img"
                  />
                  Generate Keys
                </NavLink>
              </li>
              <li className="">
                <NavLink
                  exact
                  activeClassName="active"
                  to={`${match.url}/store-listing`}
                >
                  <img
                    src={storelisting}
                    alt="logo"
                    className="sidebar_card_img"
                  />
                  Store listing
                </NavLink>
              </li>
              <li className="">
                <NavLink
                  exact
                  activeClassName="active"
                  to={`${match.url}/release-management`}
                >
                  <img
                    src={releasemanagement}
                    alt="logo"
                    className="sidebar_card_img"
                  />
                  Release Management
                </NavLink>
              </li>
              <li className="">
                <NavLink
                  exact
                  activeClassName="active"
                  to={`${match.url}/build-history`}
                >
                  <img
                    src={buildhistory}
                    alt="logo"
                    className="sidebar_card_img"
                  />
                  Build History
                </NavLink>
              </li>
              <li className="">
                <NavLink
                  exact
                  activeClassName="active"
                  to={`${match.url}/app-analytics`}
                >
                  <img
                    src={AnalyticsIcon}
                    alt="logo"
                    className="sidebar_card_img"
                  />
                  Analytics
                </NavLink>
              </li>
              <li className="">
                <a
                  // href={`/console/${projectid}/${app.id}`}
                  onClick={() => setShowComingSoon(true)}
                >
                  <img
                    src={bugreport}
                    alt="logo"
                    className="sidebar_card_img"
                  />
                  Bug reports
                </a>
              </li>
            </ul>
          </section>
        </Sidebar>
        <div className={styles.main}>
          {/**
           * * Breadcrumb
           */}
          <Breadcrumb bsPrefix="breadcrumb">
            <Breadcrumb.Item href="" onClick={() => history.push("/console")}>
              <span className="breadcrumb_item">Dashboard</span>
            </Breadcrumb.Item>
            <Breadcrumb.Item
              href=""
              onClick={() => history.push(`/console/${projectid}`)}
            >
              <span className="breadcrumb_item">{project.name}</span>
            </Breadcrumb.Item>
            <Breadcrumb.Item active>
              <span className="breadcrumb_item active">{app.title}</span>
            </Breadcrumb.Item>
          </Breadcrumb>
          <div className={styles.body}>
            {window.location.pathname.split("/").pop() === "app-analytics" ? (
              <h3 className={`${styles.heading} mlc-10`}>Analytics</h3>
            ) : (
              <h3 className={styles.heading}>{app.title}</h3>
            )}
            <Switch>
              <Route exact path={`${match.url}/`}>
                <Overview
                  app={app}
                  isLoading={isLoading}
                  isError={isError}
                  match={match}
                />
              </Route>
              <Route exact path={`${match.url}/store-listing`}>
                <AppManage
                  step={0}
                  app={app}
                  isLoading={isLoading}
                  isError={isError}
                  match={match}
                />
              </Route>
              <Route exact path={`${match.url}/release-management`}>
                <AppManage
                  step={app.graphics !== undefined ? 2 : 1}
                  app={app}
                  isLoading={isLoading}
                  isError={isError}
                  match={match}
                />
              </Route>
              <Route path={`${match.url}/build-history`}>
                <BuildHistory
                  app={app}
                  isLoading={isLoading}
                  isError={isError}
                />
              </Route>
              <Route path={`${match.url}/app-analytics`}>
                <AppAnalytics
                  app={app}
                  isLoading={isLoading}
                  isError={isError}
                />
              </Route>
              <Redirect from={`${match.url}/:wrong`} to="/not-found/" />
            </Switch>
          </div>
        </div>
      </div>
    </>
  );
};

export default App;
